import script from "./HtmlEditorDomTree.vue?vue&type=script&setup=true&lang=js"
export * from "./HtmlEditorDomTree.vue?vue&type=script&setup=true&lang=js"

import "./HtmlEditorDomTree.vue?vue&type=style&index=0&id=37c78526&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37c78526"]])

export default __exports__